import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { urls } from 'shared/entities/domain';
import { ChannelKind } from 'shared/entities/channels';
import { useProjectStore } from 'stores/index';

export type UseGoToChannelsProps = {
  openedChannelsModal: ChannelKind;
};

const useGoToChannels = ({ openedChannelsModal }: UseGoToChannelsProps) => {
  const history = useHistory();
  const projectStore = useProjectStore();

  const handleGoToChannels = React.useCallback(() => {
    if (!projectStore.projectId) {
      return;
    }

    history.push(
      urls.PROJECT.tabs.CHANNELS.create({
        projectId: projectStore.projectId
      }),
      { openedChannelsModal: openedChannelsModal }
    );
  }, [history, projectStore.projectId, openedChannelsModal]);

  return {
    handleGoToChannels
  };
};

export default useGoToChannels;
